// extracted by mini-css-extract-plugin
export default {"onsiteInfo":"InfoTooltip_onsiteInfo__RwG82","onsiteInfoTooltiptext":"InfoTooltip_onsiteInfoTooltiptext__+Yf2S"};